import PropTypes from 'prop-types';
import React from 'react';
import StripTags from 'striptags';

import {
    Footer,
    Main,
    SideBar
} from '$partials/global';

import { Stream as ModuleStream } from '$partials/modules';
import { TextInteractive } from '$partials/modules/blocks';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const JobListing = (props) => {
    // misc
    const hasHeadingMedia = (props.page?.headingImage?.px2 || props.page?.headingVideo?.url) ? true : false;

    // render
    return (
        <>
            <SideBar
                bgImage={props.page?.headingImage}
                bgVideo={props.page?.headingVideo}
                hasMedia={hasHeadingMedia}
                localePages={props.page?.translations?.edges}
                navigation={props.navigation}
                search={props.search}>
                {/* header */}
                <div className={hasHeadingMedia ? 'relative height-100vh' : ''}>
                    {/* content */}
                    <div className={hasHeadingMedia ? 'heading-image-content-offset container white': 'container'}>
                        {props.page?.headingInteractive && (
                            <div className={hasHeadingMedia ? 'module module--lesser-bottom module--sm-no-top' : 'module module--lesser-bottom'}>
                                <TextInteractive
                                    staticText={props.page?.headingText}
                                    text={props.page?.headingInteractive}
                                    textList1={props.page?.headingInteractiveList1}
                                    textList2={props.page?.headingInteractiveList2}
                                    textList3={props.page?.headingInteractiveList3}
                                    textList4={props.page?.headingInteractiveList4} />
                            </div>
                        )}

                        <div
                            className={hasHeadingMedia ? 'mln8 sm-mln9 md-mln0' : 'module'}
                            style={{ marginTop: props.page?.headingInteractive ? 0 : null }}>
                            <div className='pr-gutter mxn-gutter'> {/* outer grid gutter */}
                                <div className='flex flex-wrap'>
                                    {/* side title */}
                                    <div className='absolute top-0 md-relative md-col-2'>
                                        <div className={`px-gutter${hasHeadingMedia ? ' sm-show' : ' md-show'}`}>
                                            <p className='type-style-5 side-title'>
                                                {props.page?.title}
                                            </p>
                                        </div>
                                    </div>

                                    {/* content */}
                                    <div className='col-11 sm-col-8 md-col-7'>
                                        <div className='ml9 sm-ml9 md-ml0'>
                                            <div className='px-gutter'>
                                                {!props.page?.headingInteractive && (
                                                    <h1>
                                                        <div
                                                            className='rich-text type-style-1'
                                                            dangerouslySetInnerHTML={{ __html: StripTags(props.page?.headingText, ['mark', 'a', 'h2', 'h3', 'h4', 'hr', 'br', 'b', 'i']) }} />
                                                    </h1>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </SideBar>

            <SideBar
                className={hasHeadingMedia ? 'relative bg-white' : 'mtn7 sm-mtn7 md-mtn12'}
                isHeader={false}>
                <Main className='container'>
                    {/* modules */}
                    <ModuleStream
                        modules={props.page?.modules}
                        namespace='job-listing' />
                </Main>

                <Footer { ...props.footer }/>
            </SideBar>
        </>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    footer: PropTypes.object,
    navigation: PropTypes.object,
    page: PropTypes.shape({
        __typename             : PropTypes.string,
        headingImage           : PropTypes.object,
        headingInteractive     : PropTypes.string,
        headingInteractiveList1: PropTypes.string,
        headingInteractiveList2: PropTypes.string,
        headingInteractiveList3: PropTypes.string,
        headingInteractiveList4: PropTypes.string,
        headingVideo           : PropTypes.object,
        headingText            : PropTypes.string,
        id                     : PropTypes.string,
        listingImage           : PropTypes.object,
        metaImage              : PropTypes.object,
        metaKeywords           : PropTypes.string,
        modules                : PropTypes.array,
        searchDescription      : PropTypes.string,
        seoTitle               : PropTypes.string,
        title                  : PropTypes.string,
        translations           : PropTypes.object,
        url                    : PropTypes.string,
    }),
    search: PropTypes.object,
    translations: PropTypes.object,
    uri: PropTypes.string
};

JobListing.propTypes = propTypes;

export { JobListing };

export default JobListing;
